export var KeyCode;
(function (KeyCode) {
    KeyCode["TAB"] = "Tab";
    KeyCode["ENTER"] = "Enter";
    KeyCode["ESC"] = "Esc";
    KeyCode["SPACE"] = "Space";
    KeyCode["PAGEUP"] = "PageUp";
    KeyCode["PAGEDOWN"] = "PageDown";
    KeyCode["END"] = "End";
    KeyCode["HOME"] = "Home";
    KeyCode["ArrowLeft"] = "ArrowLeft";
    KeyCode["ArrowUp"] = "ArrowUp";
    KeyCode["ArrowRight"] = "ArrowRight";
    KeyCode["ArrowDown"] = "ArrowDown";
})(KeyCode || (KeyCode = {}));
